import { Header } from "./Header";
import { Footer } from "./Footer";
import { ShippingBanner } from "./ShippingBanner";
import { CustomCursor } from "@/components/CustomCursor";
import { usePageTracker } from "@/hooks/usePageTracker";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";

export const StoreLayout = ({ children }) => {
  usePageTracker();
  useSmoothScroll();
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <CustomCursor />
      <ShippingBanner />
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};
